import React from "react";
import { Spin } from "antd";
import { useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import useEffectOnce from '../../utils/useEffectOnce';

interface LoginUrlParams {
    id?: string;
    [key: string]: any; 
}
// 处理oidc逻辑，并重定向到登录首页
const LoginOidc: any = () => {
    const navigate = useNavigate();
    const params: LoginUrlParams = queryString.parse(window.location.search.split('?')[1] || '');
    const urlParams = {
        id: params.id
    };

    useEffectOnce(() => {
        navigate(`/login?${queryString.stringify(urlParams)}`, { replace: true });
    });

    return <Spin size="large" style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }} tip="Loading..."></Spin>
};

export default LoginOidc;